import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import {
  imageVariants,
  textVariants,
  containerVariants,
  fadeInUp,
  azxc,
  bzxc
} from '../script/animationVariants';
import GenelBilgi from '../components/detay/GenelBilgi';
import TeknikDetay from '../components/detay/TeknikDetay';
import LogoContainer from '../components/LogoContainer';
import Footer from '../components/Footer';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
// useTranslation hook'unu import ediyoruz
import { useTranslation } from 'react-i18next';
import LinkComponent from '../components/LinkComponent';

const About = () => {
  // Scroll işlemleri için ref oluşturuluyor
  const scrollRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);

  // Framer Motion ile scroll ilerleyişi ölçülüyor
  const { scrollYProgress } = useScroll({
    target: scrollRef,
    offset: ["start end", "end start"],
  });

  // scroll ilerleyişine göre konum, ölçek vb. ayarlanıyor
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  const yWithOffset = useTransform(y, (value) => `center ${parseFloat(value) + 5}%`);
  const scaleWithOffset = useTransform(y, (value) => (parseFloat(value) / 50) + 1);

  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setIsScrolling(true);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  useEffect(() => {
    console.log(scaleWithOffset);
  }, [scaleWithOffset]);

  // useTranslation hook'u ile çeviri fonksiyonunu alıyoruz
  const { t } = useTranslation();

  return (
    <div className="relative bg-red-500 overflow-hidden" ref={scrollRef}>
      {/* Arka plan resmi, scroll ile pozisyonu değiştirilmiş */}
      <motion.img
        src="/images/anasayfa/slider/3.jpg"
        className="w-full h-full absolute object-cover"
        style={{ objectPosition: yWithOffset }}
        transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1],
        }}
        animate={{
          scale: isScrolling ? 1.1 : 1,
        }}
        alt="Banner"
      />

      {/* Üstte yarı saydam siyah örtü */}
      <div className="absolute z-20 bg-gradient-to-r from-black to-transparent opacity-80 top-0 left-0 h-full w-full"></div>

      {/* İçerik alanı */}
      <motion.div
        className="h-full w-full top-0 left-0 grid grid-cols-14 py-14 relative z-40"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
      >
        <div className="col-start-2 col-span-12">
          {/* İçerik metinleri ve butonlar */}
          <motion.div
            className="h-full lg:w-1/2 text-white space-y-5"
            variants={containerVariants}
          >
            {/* Başlık: Çeviri dosyasından alınan metin */}
            <motion.h2 className="text-35" variants={textVariants}>
              {t('about.title')}
            </motion.h2>

            {/* Açıklama metni */}
            <motion.p className="text-20 font-light" variants={textVariants}>
              {t('about.slogan')}
            </motion.p>

            <motion.p className="text-20 font-light !mt-0" variants={textVariants}>
              {t('about.paragraph1')}
            </motion.p>

            <motion.p className="text-20 font-light" variants={textVariants}>
              {t('about.paragraph2')}
            </motion.p>

            <motion.p className="text-20 font-light" variants={textVariants}>
              {t('about.paragraph3')}
            </motion.p>

            <motion.p className="text-20 font-light" variants={textVariants}>
              {t('about.paragraph4')}
            </motion.p>

            {/* Buton: "Daha fazla bilgi edinin" */}
            <motion.div variants={textVariants}>
              <Link
                to="/hakkimizda"
                className="inline-block font-thin bg-[rgba(240,239,239,0.3)] py-4 px-8 text-16 transition-all duration-300 hover:scale-105"
              >
                {t('about.buttonText')}
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default About;
